import {useQueries} from "@tanstack/react-query";
import roleService from "../../../../services/web/role-service.js";
import userService from "../../../../services/web/user-service.js";
import userMessagesService from "../../../../services/web/user-messages-service.js";

const UseFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['roles'],
                queryFn: () => roleService.getAll().then((data) => data.map(item => ({value: item.id, label: item.text}))),
            },
            {
                queryKey: ['users'],
                queryFn: userMessagesService.getUserOptions
            },
            {
                queryKey: ['messagesByUser'],
                queryFn: () => userMessagesService.getByCreatedUser(),
            }
        ]
    });

    return {roles: queries[0].data, users: queries[1].data, messagesByUser: queries[2]}
};

export default UseFetchData;